import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  background: ${({ theme }) => theme.exchangeSecondBg};
  flex: 1 1 auto;
  margin-top: 10px;
  flex-grow: ${({ flexGrow }) => flexGrow};
  width: 100%;
  @media (min-width: 320px) and (max-width: 623px) {
    width: 100%;
    height: 250px;
    margin-top: 0;
  }
`

export const Title = styled.p`
  color: ${({ theme }) => theme.exchangeSectionTitleColor};
  font-size: 12px;
  text-indent: 5px;
  padding: 8px 0;
  box-shadow: ${({ theme }) => theme.exchangeHeadShadow};
`

export const Content = styled.div`
  position: absolute;
  width: 100%;
  top: 28px;
  bottom: 0;
  overflow: auto;
`

export const DateItem = styled.div`
  color: #848e9c;
  text-align: right;
`

export const ExpandCollpaseIcon = styled.div`
  position: absolute;
  top: -2px;
  right: 10px;
  cursor: pointer;
  color: ${({ theme }) => theme.exchangeIconColor};
  &:hover {
    i {
      color: ${({ theme }) => theme.highlight};
    }
  }
  @media (min-width: 320px) and (max-width: 623px) {
    display: none;
  }
`
